﻿[
  {
    "draftJersey": 201,
    "name": "Alberto Arnalot",
    "age": 32,
    "foot": "right",
    "height": 182,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/201.jpg",
    "macros": {
      "reflexes": 78,
      "handling": 80,
      "kicking": 70,
      "diving": 73,
      "average": 75
    },
    "profileYtVideoId": "nz82HUnLduU",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 203,
    "name": "Antonio Gil",
    "age": 24,
    "foot": "left",
    "height": 186,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/203.jpg",
    "macros": {
      "reflexes": 65,
      "handling": 63,
      "kicking": 50,
      "diving": 58,
      "average": 59
    },
    "profileYtVideoId": "4Dq-ZbuQswE",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 204,
    "name": "Eduardo Díez",
    "age": 43,
    "foot": "right",
    "height": 185,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/204.jpg",
    "macros": {
      "reflexes": 53,
      "handling": 58,
      "kicking": 55,
      "diving": 55,
      "average": 55
    },
    "profileYtVideoId": "GLUwEeSbssE",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 206,
    "name": "Enric Avellaneda",
    "age": 28,
    "foot": "right",
    "height": 196,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/206.jpg",
    "macros": {
      "reflexes": 40,
      "handling": 53,
      "kicking": 60,
      "diving": 58,
      "average": 53
    },
    "profileYtVideoId": "yWfDKzpj_cE",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 207,
    "name": "Javi Verger",
    "age": 22,
    "foot": "left",
    "height": 183,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/207.jpg",
    "macros": {
      "reflexes": 65,
      "handling": 65,
      "kicking": 68,
      "diving": 68,
      "average": 67
    },
    "profileYtVideoId": "gVUP_9iPlQ4",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 208,
    "name": "Francisco Nicolás",
    "age": 20,
    "foot": "right",
    "height": 182,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/208.jpg",
    "macros": {
      "reflexes": 58,
      "handling": 53,
      "kicking": 60,
      "diving": 63,
      "average": 59
    },
    "profileYtVideoId": "LS5v6zQLQao",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 209,
    "name": "Gerard Vacas",
    "age": 18,
    "foot": "right",
    "height": 177,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/209.jpg",
    "macros": {
      "reflexes": 73,
      "handling": 75,
      "kicking": 68,
      "diving": 75,
      "average": 73
    },
    "profileYtVideoId": "vg2xolfntGE",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 212,
    "name": "Manuel Martín",
    "age": 28,
    "foot": "left",
    "height": 181,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/212.jpg",
    "macros": {
      "reflexes": 80,
      "handling": 80,
      "kicking": 65,
      "diving": 75,
      "average": 75
    },
    "profileYtVideoId": "rixe-SAA56Y",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 213,
    "name": "Nicolás Monetti",
    "age": 24,
    "foot": "right",
    "height": 175,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/213.jpg",
    "macros": {
      "reflexes": 50,
      "handling": 50,
      "kicking": 60,
      "diving": 50,
      "average": 53
    },
    "profileYtVideoId": "xdSLMQxUT4U",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 214,
    "name": "Rafael Soriano",
    "age": 25,
    "foot": "right",
    "height": 178,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/214.jpg",
    "macros": {
      "reflexes": 65,
      "handling": 65,
      "kicking": 70,
      "diving": 65,
      "average": 66
    },
    "profileYtVideoId": "J3JpB8IyOho",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 215,
    "name": "Vicent Gil",
    "age": 21,
    "foot": "right",
    "height": 186,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/215.jpg",
    "macros": {
      "reflexes": 60,
      "handling": 65,
      "kicking": 60,
      "diving": 55,
      "average": 60
    },
    "profileYtVideoId": "5BIefCJpyqY",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 216,
    "name": "Víctor Vidal",
    "age": 23,
    "foot": "left",
    "height": 180,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/216.jpg",
    "macros": {
      "reflexes": 70,
      "handling": 70,
      "kicking": 70,
      "diving": 75,
      "average": 71
    },
    "profileYtVideoId": "X0hxOuzKfNo",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 217,
    "name": "Alex Romero",
    "age": 25,
    "foot": "left",
    "height": 187,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/217.jpg",
    "macros": {
      "reflexes": 60,
      "handling": 65,
      "kicking": 60,
      "diving": 55,
      "average": 60
    },
    "profileYtVideoId": "BZ3TNp35xLs",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 219,
    "name": "Eloy Amoedo",
    "age": 20,
    "foot": "right",
    "height": 171,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/219.jpg",
    "macros": {
      "reflexes": 55,
      "handling": 55,
      "kicking": 70,
      "diving": 55,
      "average": 59
    },
    "profileYtVideoId": "DLIo6J9R9uY",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 223,
    "name": "Nacho Santa",
    "age": 27,
    "foot": "right",
    "height": 188,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/223.jpg",
    "macros": {
      "reflexes": 55,
      "handling": 60,
      "kicking": 55,
      "diving": 65,
      "average": 59
    },
    "profileYtVideoId": "GYcQ-YdY3_M",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 225,
    "name": "Narcís Savov",
    "age": 18,
    "foot": "right",
    "height": 180,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/225.jpg",
    "macros": {
      "reflexes": 45,
      "handling": 50,
      "kicking": 60,
      "diving": 50,
      "average": 51
    },
    "profileYtVideoId": "cUp25u5Eyac",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 226,
    "name": "Diego Leal",
    "age": 20,
    "foot": "right",
    "height": 178,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/226.jpg",
    "macros": {
      "reflexes": 58,
      "handling": 58,
      "kicking": 58,
      "diving": 60,
      "average": 59
    },
    "profileYtVideoId": "E9tnrr-jSgg",
    "matchYtVideoId": "c89PVJ6hZJk"
  }
]
